import React from "react";
import {Avatar} from "@vkontakte/vkui";
import UserMale from "../../img/UserMale.svg";
import UserFemale from "../../img/UserFemale.svg";

const UserAvatar = ({ userInfo }) => {
  const [currentImage, setCurrentImage] = React.useState("")

  const genderAvatar = userInfo?.gender === "M" ? UserMale : UserFemale
  const avatarLink = userInfo.person?.person?.avatarLink ?? genderAvatar

  React.useEffect(() => {
    setCurrentImage(avatarLink)
  }, [avatarLink, genderAvatar])

  const setGenderAvatar = () => {
    setCurrentImage(genderAvatar)
  }

  return (
    <Avatar
      size={40}
      style={{
        marginTop: "6px",
      }}
    >
      <img
        onError={setGenderAvatar}
        src={currentImage} alt="" />
    </Avatar>
  );
};

export default UserAvatar;
